export const absenceCalendarSelector = state => state.absenceCalendar;
